<div
    class="bg-white rounded-t-2xl sm:rounded-lg w-full max-w-3xl max-h-[100vh] sm:h-auto sm:max-h-[90vh] overflow-y-auto shadow-lg mobile-scroll animate-slide-up-mobile sm:animate-none">
    <div
        class="flex justify-between items-center mobile-container mobile-safe-top !border-b !border-gray-200 !border-opacity-50">
        <div class="swipe-indicator sm:hidden"></div>
        <div
            class="flex flex-col sm:flex-row sm:items-center space-y-[8px] sm:space-y-[0px] sm:space-x-[12px] flex-1 p-[12px]">
            <h2 class="text-responsive-lg !font-semibold text-gray-900 !mb-0">
                {{ shiftData?.jobPlace?.jobPlaceName ? shiftData?.jobPlace?.jobPlaceName : "-" }}
            </h2>
        </div>
        <button (click)="closeModal()"
            class="mobile-touch-target flex items-center justify-center text-gray-400 hover:text-gray-600 touch-feedback p-[8px]">
            <svg class="lucide lucide-x" fill="none" height="20" stroke="currentColor" stroke-linecap="round"
                stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="20"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
            </svg>
        </button>
    </div>

    <div class="mobile-container mobile-space-y-[24px] p-4">
        <!-- Secttion start for display mission status dom ready publish and cancel -->
        <div
            class="relative p-[16px] bg-gradient-to-br from-muted to-muted/50 rounded-lg border border-border/50 shadow-sm">
            <h3 class="text-[14px] font-semibold text-foreground mb-[12px] flex items-center">
                {{ "guard-shift-details.onGoing.mission-status" | translate }}
            </h3>
            <div class="flex items-center justify-between mt-[-2px] flex-wrap gap-2">
                <div class="flex items-center">
                    <div class="relative group">
                        @if(isReadyShift) {
                        <span
                            class="inline-flex items-center rounded-full font-medium bg-green-50 text-green-700 px-[10px] py-[4px] text-[14px]">
                            <span class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-circle-check-big text-emerald-600">
                                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                                    <path d="m9 11 3 3L22 4"></path>
                                </svg>
                                <span class="ml-[4px]">
                                    {{ displayStatus(shiftData?.status) }}
                                </span>
                            </span>
                        </span>
                        } @if(isPublishShift) {
                        <span
                            class="inline-flex items-center rounded-full font-medium bg-yellow-50 text-yellow-700 px-[10px] py-[4px] text-[14px]">
                            <span class="flex items-center">
                                <svg class="lucide lucide-globe text-yellow-600" fill="none" height="14"
                                    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="2" viewBox="0 0 24 24" width="14" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                                    <path d="M2 12h20"></path>
                                </svg>
                               <span class="ml-[4px]">{{ displayStatus(shiftData?.status) }}</span>
                            </span>
                        </span>
                        } @if(isCancelModal) {
                        <span
                            class="inline-flex items-center rounded-full font-medium bg-red-50 text-red-700 px-[10px] py-[4px] text-[14px]">
                            <span class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-circle-x text-red-500">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="m15 9-6 6"></path>
                                    <path d="m9 9 6 6"></path>
                                </svg>
                                <span class="ml-[4px]">{{ displayStatus(shiftData?.status) }}</span>
                            </span>
                        </span>
                        }
                    </div>
                    @if ((shiftData?.guardsNumber ?? 0) &&
                    (shiftData?.guardsHiredCount ?? 0)) {
                    <span class="ml-[8px] text-[14px] text-muted-foreground">
                        {{ shiftData?.guardsHiredCount ?? 0 }}
                        {{ "guard-shift-details.onGoing.of" | translate }}
                        {{ shiftData?.guardsNumber ?? 0 }}
                        {{ "guard-shift-details.onGoing.seats-filled" | translate }}
                    </span>
                    }
                </div>
                @if(!isCancelModal && customer?.employeeRole?.id != 3) {
                <button (click)="openCancelModal()"
                    class="inline-flex items-center gap-[8px] px-[12px] py-[8px] text-[14px] text-destructive hover:text-destructive/80 hover:bg-destructive/5 rounded-lg transition-colors border border-destructive/20 hover:border-destructive/30 focus:outline-none outline-none">
                    <svg class="lucide lucide-circle-alert" fill="none" height="16" stroke="currentColor"
                        stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="16"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" x2="12" y1="8" y2="12"></line>
                        <line x1="12" x2="12.01" y1="16" y2="16"></line>
                    </svg>
                    {{ "guard-shift-details.cancel.cancel-shift" | translate }}
                </button>
                }
            </div>
        </div>
        <!-- Secttion end for display mission status dom ready publish and cancel -->

        <!-- Secttion start for display booked guard -->
        <div [class]="shiftData?.hired?.length > 0 ? 'space-y-[28px]' : 'space-y-[16px]'">
            <div [class]="shiftData?.hired?.length > 0 ? 'space-y-[12px]' : ''">
                <h3 [class]="'text-[14px] !font-semibold text-foreground flex items-center ' + (shiftData?.hired?.length > 0 ? '!mb-[16px] !mt-[24px]' : '!mb-[8px] !mt-[16px]')">
                    {{ "guard-shift-details.onGoing.booked-guards" | translate }}:
                    {{ shiftData?.guardsHiredCount ?? (shiftData?.hired ? shiftData?.hired?.length : 0) }}
                </h3>
                <div [class]="shiftData?.hired?.length > 0 ? 'grid grid-cols-1 sm:grid-cols-2 gap-[12px]' : ''">
                    @for(data of shiftData?.hired; track (data?.id ? data.id + '-' + $index : $index)) {
                    <div (click)="showGuardDetails(data)"
                        class="flex items-center gap-[12px] p-[12px] bg-muted/30 rounded-lg border border-border/50 cursor-pointer hover:bg-muted/40 transition-colors shadow-sm">
                        <div class="relative">
                            @if(data?.image) {
                            <img alt="{{data?.firstName || data?.aliasName}}"
                                class="w-[48px] h-[48px] rounded-full object-cover" src="{{ data?.image }}" />
                            } @else{
                            <div
                                class="w-[48px] h-[48px] rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center text-blue-700 font-bold text-sm ring-2 ring-background shadow-sm">
                                {{ ( data?.aliasName?.charAt(0) || data?.firstName?.charAt(0) || '-' ).toUpperCase() }}
                            </div>
                            } @if(totalShiftsForCustomer > commonConstants.TOTAL_CUSTOMER_SHIFT_MORE_THAN_SEVENTY)
                            {
                                <div class="absolute -bottom-1 -right-1 bg-green-600 rounded-full p-[4px]">
                                    <svg fill="none" height="16" viewBox="0 0 24 24" width="16"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 16.2L4.8 12L3.4 13.4L9 19L21 7L19.6 5.6L9 16.2Z" fill="white"></path>
                                    </svg>
                                </div>
                            }
                        </div>
                        <div class="flex-1 min-w-0">
                            <div class="font-medium text-sm">
                                @if (data?.firstName || data?.aliasName) {
                                {{ (data?.aliasName ? data.aliasName : (data?.firstName ? data.firstName : '-')) }}
                                } @else { - }
                            </div>
                            @if(data?.reliabilityPercentage){
                                <div class="text-xs text-muted-foreground">
                                    {{ data?.reliabilityPercentage }}%
                                    {{ "guard-shift-details.onGoing.reliability" | translate }}
                                </div>
                                <div class="text-xs text-blue-600">
                                    {{ data?.totalShiftsForCustomer }}
                                    {{ "guard-shift-details.onGoing.passports-for-you" | translate }}
                                </div>
                            }
                        </div>
                    </div>
                    <!-- Display button forselect guard for publish and ready Modal -->
                    } @if (shiftData?.engagementType === 2 &&
                    shiftData?.guardsHiredCount !== shiftData?.guardsNumber &&
                    !isCancelModal && shiftData?.applied?.length > 0 && customer?.employeeRole?.id != 3) {
                    <button (click)="opneBookGuardPanel()"
                        class="flex items-center gap-[12px] px-[12px] py-[12px] bg-muted/10 rounded-lg border border-border/30 border-dashed hover:bg-muted/20 hover:border-border/50 transition-colors hover:shadow-sm">
                        <div
                            class="w-[48px] h-[48px] rounded-full border-[1px] border-dashed border-[#bdb6b6] bg-primary/5 flex items-center justify-center">
                            <span class="!text-gray-900 text-[20px] font-bold">+</span>
                        </div>
                        <div class="flex-1 min-w-0 text-left">
                            <div class="font-medium text-[14px] !text-gray-900">
                                {{ "guard-shift-details.common.add-more" | translate }}
                            </div>
                            <div class="text-[12px] text-muted-foreground">
                                {{ shiftData?.applied?.length }}
                                {{ "guard-shift-details.common.no-of-applied" | translate }}
                            </div>
                        </div>
                    </button>
                    }
                </div>

                <!--Start section Open panel for select guard for publish and ready Modal -->
                @if(isShowAddGuardBookedPanel && shiftData.applied?.length > 0) {
                <div class="border border-[rgba(222,226,230,0.5)] rounded-[12px] bg-white p-[16px] shadow-sm mt-[12px]">
                    <div class="flex justify-between items-center mb-[12px]">
                        <h3 class="text-[14px] font-semibold text-foreground mb-0">
                            {{ "create-assignment.step3.available-guards" | translate }}
                        </h3>
                        <button (click)="hideBookGuardPanel()"
                            class="p-[4px] text-muted-foreground hover:text-foreground transition-colors rounded-full hover:bg-gray-100">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-x">
                                <path d="M18 6 6 18"></path>
                                <path d="m6 6 12 12"></path>
                            </svg>
                        </button>
                    </div>
                    <div class="space-y-[8px]">
                        @for(apply of shiftData.applied; track apply) {
                            <div class="flex items-center justify-between bg-gray-50 rounded-[8px] p-[12px] border border-gray-100">
                                <div class="flex items-center gap-[12px] cursor-pointer flex-1 min-w-0" (click)="showGuardDetails(apply)">
                                    @if(apply.image) {
                                    <img src="{{ apply?.image }}" alt="{{apply?.firstName || apply?.aliasName}}"
                                        class="w-[44px] h-[44px] rounded-full object-cover flex-shrink-0" />
                                    } @else{
                                    <div
                                        class="w-[44px] h-[44px] rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center text-blue-700 font-bold text-sm ring-2 ring-background shadow-sm flex-shrink-0">
                                    {{ ( apply.aliasName?.charAt(0) || apply.firstName?.charAt(0) || '-' ).toUpperCase() }}
                                    </div>
                                    }
                                    <div class="min-w-0 flex-1">
                                        <div class="font-medium text-[14px] truncate">
                                            @if (apply.firstName || apply.aliasName)
                                            { 
                                                {{ (apply?.aliasName ? apply.aliasName : (apply?.firstName ? apply.firstName : '-')) }} 
                                            } @else { - }
                                        </div>
                                        <div class="text-[12px] text-muted-foreground">
                                            <span class="text-600 font-medium">{{ apply.reliabilityPercentage }}%</span>
                                            {{ "guard-shift-details.onGoing.reliability" | translate }}
                                        </div>
                                        <div class="text-[12px] text-blue-600">
                                            {{ apply.totalShiftsForCustomer }}
                                            {{ "guard-shift-details.onGoing.passports-for-you" | translate }}
                                        </div>
                                    </div>
                                </div>
                                <button (click)="bookedGuard(apply)"
                                    class="inline-flex items-center gap-[6px] rounded-[8px] px-[12px] py-[8px] bg-primary/10 hover:bg-primary/20 transition-colors text-[13px] font-medium text-primary flex-shrink-0 ml-[8px]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-user-plus">
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="9" cy="7" r="4"></circle>
                                        <line x1="19" x2="19" y1="8" y2="14"></line>
                                        <line x1="22" x2="16" y1="11" y2="11"></line>
                                    </svg>
                                    {{ "guard-shift-details.common.book-in" | translate }}
                                </button>
                            </div>
                        }
                    </div>
                </div>
                }
                <!-- End section Open panel for select guard for publish and ready Modal -->
            </div>

            <!--section start Crad for display work place and skill required -->
            <div class="space-y-[24px]">
                <!-- work place and skill -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <!-- Workplace Card -->
                    <div class="bg-card rounded-lg p-4 border border-border shadow-sm">
                        <h3 class="font-semibold text-foreground mb-3 flex items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-map-pin mr-2">
                                <path
                                    d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
                                </path>
                                <circle cx="12" cy="10" r="3"></circle>
                            </svg>
                            {{ "guard-shift-details.onGoing.work-place" | translate }}
                        </h3>
                        <div class="text-sm text-muted-foreground">
                            {{ shiftData.jobPlace.jobPlaceName ? shiftData.jobPlace.jobPlaceName : "-" }}
                        </div>
                    </div>

                    <!-- Personnel Card -->
                    <div class="bg-card rounded-lg p-4 border border-border shadow-sm">
                        <h3 class="font-semibold text-foreground mb-3 flex items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-users mr-2">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                            {{ "guard-shift-details.onGoing.competency-requirements" | translate }}
                        </h3>
                        <div class="text-sm text-muted-foreground">
                            @if(shiftData?.skill?.name) {
                            {{ shiftData?.skill?.name }} } @else{ - }
                        </div>
                    </div>
                </div>
                <!--Section end Crad for display work place and skill required -->

                <!--Section start for display job description and edit -->
                <div
                    class="group relative p-[16px] bg-card rounded-xl border border-border/50 shadow-sm hover:shadow-md transition-all duration-300">
                    <div class="flex items-center justify-between mb-[12px]">
                        <h3 class="text-[14px] font-semibold text-foreground flex items-center !mb-0">
                            <div class="p-[8px] rounded-lg bg-primary/10 !mr-0">
                                <svg class="lucide lucide-file-text !mr-0" fill="none" height="16" stroke="currentColor"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
                                    width="16" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                                    <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                                    <path d="M10 9H8"></path>
                                    <path d="M16 13H8"></path>
                                    <path d="M16 17H8"></path>
                                </svg>
                            </div>
                            {{ "guard-shift-details.onGoing.job-description" | translate }}
                        </h3>
                        @if(!isShowJobDescriptionEditButton && !isCancelModal && customer?.employeeRole?.id != 3) {
                        <button (click)="editJobDscription()"
                            class="p-[6px] rounded-lg text-muted-foreground hover:text-foreground hover:bg-accent transition-colors">
                            <svg class="lucide lucide-pen" fill="none" height="14" stroke="currentColor"
                                stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
                                width="14" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z">
                                </path>
                            </svg>
                        </button>
                        } @if(isShowEditDescriptionSection && isShowJobDescriptionEditButton) {
                        <div class="flex gap-2">
                            <!-- Save button -->
                            <button type="submit" (click)="saveDescription()"
                                class="text-green-600 hover:text-green-800" title="Save">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                                </svg>
                            </button>

                            <!-- Cancel button -->
                            <button type="button" (click)="cancelEdit()" class="text-red-600 hover:text-red-800"
                                title="Cancel">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        }
                    </div>
                    @if(!isShowEditDescriptionSection && shiftData.description)
                    {
                    <p class="text-[14px] text-muted-foreground leading-relaxed !mb-0 m-2 break-words">
                        {{ shiftData?.description }}
                    </p>

                    }
                    <!-- Edit job description -->
                    @if(isShowEditDescriptionSection) {
                    <form [formGroup]="form" class="space-y-2">
                        <textarea formControlName="description" rows="3"
                            class="w-full text-[14px] text-foreground p-2 border border-border rounded-md resize-none focus:outline-none focus:ring focus:ring-accent"
                            [placeholder]="'guard-shift-details.common.enterJobDescription' | translate">
                        </textarea>
                    </form>
                    }
                </div>
                <!--Section end for display job description and edit -->

                <!--Section start for display shift time and edit -->
                <div
                    class="group relative p-[16px] bg-card rounded-xl border border-border/50 shadow-sm hover:shadow-md transition-all duration-300">
                    <div class="flex items-center justify-between mb-[12px]">
                        <h3 class="text-[14px] font-semibold text-foreground flex items-center !mb-0">
                            <div class="p-[8px] rounded-lg bg-primary/10 !mr-0">
                                <svg class="lucide lucide-clock !mr-0" fill="none" height="16" stroke="currentColor"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
                                    width="16" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <polyline points="12 6 12 12 16 14"></polyline>
                                </svg>
                            </div>
                            {{ "guard-shift-details.onGoing.working-hours" | translate }}
                        </h3>
                        @if(!isShowShiftButton && !isCancelModal && customer?.employeeRole?.id != 3) {
                        <button (click)="editshifttime()"
                            class="p-[6px] rounded-lg text-muted-foreground hover:text-foreground hover:bg-accent transition-colors">
                            <svg class="lucide lucide-pen" fill="none" height="14" stroke="currentColor"
                                stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
                                width="14" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z">
                                </path>
                            </svg>
                        </button>
                        } @if( isShowtimeShiftSection && isShowShiftButton) {
                        <div class="flex gap-2">
                            <!-- Save button -->
                            <button type="submit" (click)="saveShiftTime()"
                                class="text-green-600 hover:text-green-800 disabled:text-gray-400" [disabled]="
                                    durationInHours < 0 || durationInHours > 13
                                ">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                                </svg>
                            </button>
                            <!-- Cancel button -->
                            <button type="button" (click)="cancelShiftTime()" class="text-red-600 hover:text-red-800"
                                title="Cancel">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        }
                    </div>
                    @if (shiftData?.startTime && shiftData?.endTime && !isShowtimeShiftSection) {
                    <p class="text-[14px] text-muted-foreground font-medium !mb-0 m-2">
                        {{ shiftData?.startTime }} - {{ shiftData?.endTime }}
                    </p>
                    }
                    <!-- Edit time slot -->
                    @if(isShowtimeShiftSection) {
                    <form [formGroup]="updateShiftHoursForm">
                        <div class="flex items-center gap-2">
                            <!-- Start Time -->
                            <div class="relative">
                                <input type="time" formControlName="startTime" (change)="onTimeChange()"
                                    class="w-full md:w-[150px] pr-2 pl-2 py-1 text-sm border rounded-md focus:outline-none focus:ring-2"
                                    [ngClass]="{
                                        'border-red-500 ring-red-300':
                                            isShiftInvalid,
                                        'border-gray-300 focus:ring-accent':
                                            !isShiftInvalid
                                    }" />
                            </div>

                            <!-- Dash -->
                            <span class="text-gray-500 text-sm">—</span>

                            <!-- End Time -->
                            <div class="relative">
                                <input type="time" formControlName="endTime" (change)="onTimeChange()"
                                    class="w-full md:w-[150px] pr-2 pl-2 py-1 text-sm border rounded-md focus:outline-none focus:ring-2"
                                    [ngClass]="{
                                        'border-red-500 ring-red-300':
                                            isShiftInvalid,
                                        'border-gray-300 focus:ring-accent':
                                            !isShiftInvalid
                                    }" />
                            </div>
                        </div>

                        <!-- Time Difference and Validation -->
                        <div class="mt-2 text-sm" *ngIf="durationInHours !== null">
                            <span [ngClass]="{
                                    'text-red-600': isShiftInvalid,
                                    'text-gray-700': !isShiftInvalid
                                }">
                                {{ "guard-shift-details.common.shift-duration" | translate }}: {{ durationDisplay }}
                            </span>
                            <div *ngIf="isShiftInvalid" class="text-red-600 text-xs mt-1">
                                {{ "guard-shift-details.common.shift-hours-between-one-to-thirteen" | translate }}
                            </div>
                        </div>
                    </form>
                    }
                </div>
                <!--Section end for display shift time and edit -->

                <!--Section start for display securiti panel  -->
                @if(isReadyShift || isPublishShift) {
                <div
                    class="group relative p-[20px] bg-gradient-to-br from-card to-card/50 rounded-xl border border-border/50 shadow-sm hover:shadow-lg transition-all duration-300">
                    <div class="flex items-center justify-between">
                        <h3 class="text-[18px] !font-semibold text-foreground flex items-center">
                            <div
                                class="p-[8px] rounded-lg bg-primary/10 mr-[12px] group-hover:bg-primary/15 transition-colors">
                                <svg class="lucide lucide-users" fill="none" height="18" stroke="currentColor"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
                                    width="18" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="9" cy="7" r="4"></circle>
                                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                </svg>
                            </div>
                            {{ "guard-shift-details.common.security-staffing" | translate }}
                        </h3>
                    </div>
                    <div class="bg-muted/30 rounded-lg pb-[16px] md:p-[16px]">
                        <div class="flex items-center justify-between flex-wrap gap-3">
                            <div class="flex items-center gap-[16px]">
                                <div
                                    class="inline-flex items-center justify-center min-w-[48px] h-[48px] bg-primary/10 rounded-full ring-2 ring-[#adccff] transition-all duration-500">
                                    <span class="text-[20px] font-bold">{{ shiftData?.guardsNumber }}</span>
                                </div>
                              <div>
                            <div class="text-[14px] font-medium text-foreground">
                                {{ shiftData?.guardsNumber === 1 
                                ? ('guard-shift-details.common.guardian-needed' | translate) 
                                : ('guard-shift-details.common.guardians-needed' | translate) }}
                            </div>

                             @if (shiftData?.guardsHiredCount && shiftData?.guardsNumber) {
                                <div class="text-[12px] text-muted-foreground">
                                {{ shiftData.guardsHiredCount }}
                                {{ 'guard-shift-details.onGoing.of' | translate }}
                                {{ shiftData.guardsNumber }}
                                {{ shiftData?.guardsNumber === 1 
                                    ? ('guard-shift-details.onGoing.booked-guards' | translate) 
                                    : ('guard-shift-details.onGoing.booked-guardes' | translate) }}
                                </div>
                            }
                            </div>

                            </div>
                            <div class="text-right">
                                  @if(customer?.employeeRole?.id != 3)
                                  {
                                     <div class="text-[14px] font-medium text-foreground">
                                          {{ "guard-shift-details.common.current-cost" | translate }}
                                      </div>
                                
                                <div class="text-[18px] font-bold" style="text-align: left;" >
                                   {{ (getGuardChangeData(shiftData, guardCount).cost) | currencyFormat }}
                                </div>
                                  }
                            </div>
                        </div>
                    </div>
                    <!-- @if(customer?.employeeRole?.id != 3)
                    { -->
                        @if(shiftData.duration !== 0 && customer?.employeeRole?.id != 3 ) {
                        <div class="space-y-[16px]">
                            <div class="bg-blue-50/30 rounded-lg p-[16px] border border-blue-200/30">
                                <div class="flex items-center justify-between mb-[12px]">
                                    <span class="text-[14px] font-medium text-foreground">
                                        {{ "guard-shift-details.common.adjust-number-of-guard"  | translate }}
                                    </span>
                                    <!-- Minus button, disabled example -->
                                    <div class="flex items-center gap-[8px]">
                                        <button 
                                            (click)="decreaseGuardCount()" 
                                            [disabled]="guardCount <= shiftData?.guardsNumber"
                                            class="w-[32px] h-[32px] rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-accent transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                                            <svg class="lucide lucide-minus" fill="none" height="14" stroke="currentColor"
                                                stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                viewBox="0 0 24 24" width="14" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 12h14"></path>
                                            </svg>
                                        </button>
                                        <div
                                            class="w-[64px] h-[40px] rounded-lg bg-background border border-border flex items-center justify-center">
                                            <input disabled type="number" [value]="guardCount" min="1"
                                                class="w-full h-full text-center items-center font-bold pl-0 md:!pl-3 lg:!pl-3 text-foreground bg-transparent outline-none" />
                                        </div>
    
                                        <!-- Plus button -->
                                        <button (click)="increaseGuardCount()"
                                            class="w-[32px] h-[32px] rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-accent transition-colors">
                                            <svg class="lucide lucide-plus" fill="none" height="14" stroke="currentColor"
                                                stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                viewBox="0 0 24 24" width="14" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 12h14"></path>
                                                <path d="M12 5v14"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div class="text-[12px] text-muted-foreground mb-[12px]">
                                    {{ "guard-shift-details.common.can-booked-guard" | translate }}:
                                    {{ shiftData?.costPerGuard ? (shiftData.costPerGuard | currencyFormat) : "-" }}
                                </div>
    
                                @if(showPlusBox) {
                                <div class="space-y-[8px]">
                                    <div class="flex items-center gap-[8px] text-[14px]">
                                        <div class="w-[8px] h-[8px] rounded-full bg-green-500"></div>
                                        <span class="text-green-700">
                                            <span>
                                               <span>
                                                {{
                                                    (guardCount - shiftData.guardsNumber) === 1
                                                    ? ("guard-shift-details.common.more-guards-needed" | translate : { count: guardCount - shiftData.guardsNumber })
                                                    : ("guard-shift-details.common.more-guards-needed_plural" | translate : { count: guardCount - shiftData.guardsNumber })
                                                }}
                                                </span>

                                            </span>
                                        </span>
                                    </div>
                                    <div
                                        class="mt-[16px] p-[16px] bg-gradient-to-r from-green-50 to-yellow-50 border-2 border-green-200/60 rounded-lg shadow-sm transition-all duration-300">
                                        <div class="flex items-start gap-[12px] mb-[16px]">
                                            <div
                                                class="flex-shrink-0 w-[32px] h-[32px] rounded-full bg-green-100 flex items-center justify-center mt-0">
                                                <svg class="lucide lucide-circle-alert text-green-600" fill="none"
                                                    height="18" stroke="currentColor" stroke-linecap="round"
                                                    stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="18"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <line x1="12" x2="12" y1="8" y2="12"></line>
                                                    <line x1="12" x2="12.01" y1="16" y2="16"></line>
                                                </svg>
                                            </div>
                                            <div class="flex-1">
                                                <h4 class="text-[14px] font-semibold text-green-900 mt-1 mb-[4px]">
                                                    {{ "guard-shift-details.common.add-guard" | translate }}
                                                </h4>
                                                <p class="text-[12px] text-green-700 leading-relaxed">
                                                    <span class="font-bold">
                                                        {{ 'guard-shift-details.common.guard-change-cost-increase' | translate : { 
                                                            oldCount: shiftData.guardsNumber, newCount: guardCount, cost: (guardCount * shiftData.costPerGuard) | currencyFormat 
                                                        } }}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="flex items-center gap-[12px] flex-wrap">
                                            <button (click)="saveGuardCount()"
                                                class="flex-1 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg px-[16px] py-[12px] text-[14px] font-semibold hover:from-green-700 hover:to-green-800 transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-[8px] disabled:opacity-75 disabled:cursor-not-allowed">
                                                <svg class="lucide lucide-check" fill="none" height="16"
                                                    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                                    stroke-width="2" viewBox="0 0 24 24" width="16"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M20 6 9 17l-5-5"></path>
                                                </svg>
                                                {{ "guard-shift-details.common.confirm-changes" | translate }}
                                            </button>
                                            <button (click)="dismissCount()"
                                                class="px-[16px] py-[12px] bg-white border-2 border-gray-300 rounded-lg text-[14px] font-medium text-gray-700 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 flex items-center justify-center gap-[8px] disabled:opacity-50">
                                                <svg class="lucide lucide-x" fill="none" height="16" stroke="currentColor"
                                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M18 6 6 18"></path>
                                                    <path d="m6 6 12 12"></path>
                                                </svg>
                                                {{ "guard-shift-details.common.cancel" | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                } @if(showMinusBox) {
                                <div class="space-y-[8px]">
                                    <div class="flex items-center gap-[8px] text-[14px]">
                                        <div class="w-[8px] h-[8px] rounded-full bg-orange-500"></div>
                                        <span class="text-orange-700">
                                            {{ "guard-shift-details.common.more-guards-needed" | translate : { 
                                                count: guardCount - shiftData.guardsNumber 
                                            } }}
                                        </span>
                                    </div>
                                    <div
                                        class="mt-[16px] p-[16px] bg-gradient-to-r from-orange-50 to-yellow-50 border-2 border-orange-200/60 rounded-lg shadow-sm transition-all duration-300">
                                        <div class="flex items-start gap-[12px] mb-[16px]">
                                            <div
                                                class="flex-shrink-0 w-[32px] h-[32px] rounded-full bg-orange-100 flex items-center justify-center mt-0">
                                                <svg class="lucide lucide-circle-alert text-orange-600" fill="none"
                                                    height="18" stroke="currentColor" stroke-linecap="round"
                                                    stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="18"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <line x1="12" x2="12" y1="8" y2="12"></line>
                                                    <line x1="12" x2="12.01" y1="16" y2="16"></line>
                                                </svg>
                                            </div>
                                            <div class="flex-1">
                                                <h4 class="text-[14px] font-semibold text-green-900 mt-1 mb-[4px]">
                                                    {{ "guard-shift-details.common.remove-guard" | translate }}
                                                </h4>
                                                <p class="text-[12px] text-orange-700 leading-relaxed">
                                                    <span class="font-bold">
                                                      
                                                  {{ 'guard-shift-details.common.guard-change-cost-increase' | translate : { 
                                                            oldCount: shiftData.guardsNumber, newCount: guardCount, cost: (guardCount * shiftData.costPerGuard) | currencyFormat 
                                                        } }}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="flex items-center gap-[12px] flex-wrap">
                                            <button (click)="saveGuardCount()"
                                                class="flex-1 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg px-[16px] py-[12px] text-[14px] font-semibold hover:from-green-700 hover:to-green-800 transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-[8px] disabled:opacity-75 disabled:cursor-not-allowed">
                                                <svg class="lucide lucide-check" fill="none" height="16"
                                                    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                                    stroke-width="2" viewBox="0 0 24 24" width="16"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M20 6 9 17l-5-5"></path>
                                                </svg>
                                                {{ "guard-shift-details.common.confirm-changes" | translate }}
                                            </button>
                                            <button (click)="dismissCount()"
                                                class="px-[16px] py-[12px] bg-white border-2 border-gray-300 rounded-lg text-[14px] font-medium text-gray-700 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 flex items-center justify-center gap-[8px] disabled:opacity-50">
                                                <svg class="lucide lucide-x" fill="none" height="16" stroke="currentColor"
                                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M18 6 6 18"></path>
                                                    <path d="m6 6 12 12"></path>
                                                </svg>
                                                {{ "guard-shift-details.common.cancel" | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                        } @else{
                            <span *ngIf="customer?.employeeRole?.id != 3; else bookedGuardsAlt">
                            <p>
                            {{ "guard-shift-details.common.select-guard" | translate }}
                          </p>
                            </span>
                             <ng-template #bookedGuardsAlt>
                            {{ shiftData.guardsHiredCount }}
                            {{ 'guard-shift-details.onGoing.outOf' | translate }}
                            {{ shiftData.guardsNumber }}
                            {{ 'guard-shift-details.onGoing.guardIsBooked' | translate }}
                            </ng-template>
                         <!-- <p>
                            {{ "guard-shift-details.common.select-guard" | translate }}
                          </p> -->
                        }
                    <!-- } -->
                </div>
                <!--Section start for display securiti panel  -->
                }

                <!-- Assignment summary component -->
                   @if(customer?.employeeRole?.id != 3)
                   {
                        <app-assigment-shift-summary-calculation
                       [costPerGuard]="shiftData.costPerGuard"
                       [duration]="shiftData.duration" 
                       [guardCount]="getGuardChangeData(shiftData, guardCount).newCount ||shiftData.guardsNumber"
                       [totalCost]="getGuardChangeData(shiftData, guardCount).cost || shiftData.totalCost">
                       </app-assigment-shift-summary-calculation>
                   }
            </div>
        </div>
    </div>
</div>